import { CELL_HEIGHT, CELL_WIDTH } from '@diagram/diagram-dimensions';
import { ComponentInstanceService } from '@diagram/services/ComponentInstanceService';
import { ViewportService } from '@diagram/services/ViewportService';
import { zonesState } from '@diagram/state/zones';

import { CURRENT_OS_ZONE_ORDER, CurrentOSZoneType, Zone, ZoneValidationError } from 'models';

const ZoneService = {
    temporary: (connections: Zone['connections'], componentInstances: Zone['componentInstances']) => {
        return {
            id: 'temporary',
            type: 'control',
            connections,
            componentInstances,
        } as Zone;
    },

    highlight: (zone: Zone | null = null, error: ZoneValidationError | null = null) => {
        const componentsToHighlight: string[] = [];

        if (!zone || zone?.id === 'temp' || zone?.id === 'temporary') {
            zonesState.temp = zone;
        }

        zonesState.highlight = zone ? zone.id : null;

        if (error) {
            componentsToHighlight.push(...error.payload.componentInstances.map((x) => x.id));
        }

        document.querySelectorAll(`[data-selectable-type="component-instance"]`).forEach((element) => {
            const id = element.getAttribute('data-selectable-id')!;

            if (!zone) {
                // @ts-ignore
                element.removeAttribute('data-highlighted');
                return;
            }

            if (componentsToHighlight.includes(id)) {
                ComponentInstanceService.highlight(id, 'error');
            }
        });
    },

    lowlight: () => {
        ZoneService.highlight(null);
    },

    setAllCurrentOSZonesVisible: (visible: boolean) => {
        ZoneService.setVisibleCurrentOSZoneTypes(visible ? [...CURRENT_OS_ZONE_ORDER] : []);
    },

    toggleCurrentOSZoneType: (type: CurrentOSZoneType) => {
        const visible = zonesState.visibleCurrentOSZoneTypes;

        ZoneService.setVisibleCurrentOSZoneTypes(
            visible.includes(type) ? visible.filter((visibleType) => visibleType !== type) : [...visible, type],
        );
    },

    setVisibleCurrentOSZoneTypes: (types: CurrentOSZoneType[]) => {
        const ordered = CURRENT_OS_ZONE_ORDER.filter((type) => types.includes(type));

        zonesState.visibleCurrentOSZoneTypes = ordered;
    },

    hoverCurrentOSZoneType: (type: CurrentOSZoneType | null) => {
        zonesState.hoveredCurrentOSZoneType = type;
    },

    moveIntoView: (zone: Zone) => {
        const { componentInstances } = zone;

        const xs = componentInstances.map((componentInstance) => componentInstance.position.x);
        const ys = componentInstances.map((componentInstance) => componentInstance.position.y);

        const x = Math.min(...xs);
        const y = Math.min(...ys);

        ViewportService.moveIntoView({
            x: x * CELL_WIDTH + CELL_WIDTH / 2,
            y: y * CELL_HEIGHT + CELL_HEIGHT / 2,
        });
    },
};

export { ZoneService };
